export { default } from './BancoAutoMotoDesktop';
